/**
 * The status bar: engine, folders, playback settings, layout -- plus plugin items.
 * Desktop app only (owner, 2026-11-01: "it is the web, this is also not needed"); on
 * the web it shows only while the engine cannot be reached, to say so.
 */

import { useApp } from "../core/app";
import { usePlayer } from "../core/player";
import { useRegistry } from "../core/registry";
import { isDesktop } from "../platform";

export const VERSION = __NOVA_VERSION__;

export function StatusBar() {
  const app = useApp();
  const p = usePlayer();
  const { statusItems, layouts } = useRegistry();
  const watching = app.library.status?.watch?.roots.length ?? 0;
  const layout = layouts.find((l) => l.id === app.layout)?.label ?? app.layout;
  if (!isDesktop() && !app.offline) return null;
  return (
    <div className="nv-status" role="contentinfo">
      <span className={app.offline ? "bad" : "ok"}>
        <span className={`nv-led ${app.offline ? "bad" : "ok"}`} /> {app.offline ? (app.library.state === "connecting" ? "Connecting…" : "Engine offline · sample data") : "Engine running"}
      </span>
      {!app.offline && <span>{watching ? `Watching ${watching} folder${watching === 1 ? "" : "s"}` : "No folders yet"}</span>}
      <span>
        {p.crossfade ? `Crossfade ${p.crossfade} s` : "Gapless"}
        {p.levelling ? " · Volume levelling on" : ""}
      </span>
      {statusItems.filter((s) => s.side !== "right").map((s) => <span key={s.id}>{s.render()}</span>)}
      <span className="nv-spacer" />
      {statusItems.filter((s) => s.side === "right").map((s) => <span key={s.id}>{s.render()}</span>)}
      <button className="nv-link" onClick={() => app.theme.cycle()} title="Change theme">
        Theme: {app.theme.choice === "system" ? `System (${app.theme.resolved})` : app.theme.choice === "dark" ? "Dark" : "Light"}
      </button>
      <span>Layout: {layout}</span>
      <span>v{VERSION}</span>
    </div>
  );
}
